import {
  GetReportDocumentUploadUrlMutation,
  GetReportUploadReadUrlForReporterMutation,
  useGetReportDocumentUploadUrlMutation,
  useGetReportUploadReadUrlForReporterMutation,
} from 'src/graphql/generated';

import { FileEvidenceForDataDeletionType } from 'src/components/pages/Case/Case.slice';
import { stripFileExtension } from 'src/utils';
import { UploadedEvidenceFile } from '../types';

export const useGetReadURL = (caseManagerView: boolean, reportId: string) => {
  const useHook = caseManagerView
    ? useGetReportDocumentUploadUrlMutation
    : useGetReportUploadReadUrlForReporterMutation;

  const getReadURLMutation = useHook();

  const getReadUrl = async (
    file: UploadedEvidenceFile | FileEvidenceForDataDeletionType,
  ): Promise<string> => {
    if (file.directFileUrl) {
      return file.directFileUrl;
    }

    if (!file.fileS3Path) {
      return '';
    }

    let strippedPath = stripFileExtension(file.fileS3Path);

    if (strippedPath.startsWith('[') && strippedPath.endsWith(']')) {
      strippedPath = strippedPath.slice(1, -1);
    }

    const result = await getReadURLMutation.mutateAsync({
      reportId,
      objectId: strippedPath,
    });

    return caseManagerView
      ? (result as GetReportDocumentUploadUrlMutation)
          .getReportDocumentUploadURL.url
      : (result as GetReportUploadReadUrlForReporterMutation)
          .getReportUploadReadURLForReporter.url;
  };

  return {
    getReadUrl,
  };
};
